import { headerMobileLinkLightSX } from '@/components/content/Header/styles/mobileDrawer';
import { Box } from '@mui/material';
import { MobileLink } from '@/components/content/Header/parts/MobileLink';
import { useUserCheckLoggedIn } from '@/data/User';
import { useLocalization } from '@/data/Localization';
import { ACCOUNT_QUERY_TABS } from '@/components/content/Account';
import { ExitToAppOutlined } from '@mui/icons-material';
import { useLogout } from '@/data/Content/Logout';
import { ShowByCondition } from '@/components/blocks/ShowByCondition';

export const ActionsLinks: React.FC<{ closeDrawer?: () => void }> = ({ closeDrawer }) => {
	const { isLoggedIn } = useUserCheckLoggedIn();
	const RouteLocal = useLocalization('Routes');
	const { handleLogout } = useLogout();

	const linksToActions = [
		{
			name: isLoggedIn ? 'Mi cuenta' : 'Mi cuenta / Registro',
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18">
					<path
						id="person"
						d="M136.5,138.763A15.86,15.86,0,0,1,142.421,140q3.079,1.237,3.079,3.237V145.5h-18v-2.263q0-2,3.079-3.237A15.86,15.86,0,0,1,136.5,138.763Zm0-2.263a4.493,4.493,0,0,1-4.474-4.474,4.394,4.394,0,0,1,1.316-3.184,4.386,4.386,0,0,1,6.316,0,4.394,4.394,0,0,1,1.316,3.184A4.493,4.493,0,0,1,136.5,136.5Z"
						transform="translate(-127.5 -127.5)"
						fill="currentColor"
					/>
				</svg>
			),
			authRoute: true,
			href: {
				pathname: `/${RouteLocal.Account.route.t()}`,
				query: { tab: ACCOUNT_QUERY_TABS.RESUME },
			},
		},
		{
			name: 'Mis Favoritos',
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20.571 18">
					<path
						id="heart-solid"
						d="M18.562,33.2a5.494,5.494,0,0,0-7.5.546l-.792.816-.792-.816a5.494,5.494,0,0,0-7.5-.546,5.769,5.769,0,0,0-.4,8.353l7.774,8.028a1.26,1.26,0,0,0,1.82,0l7.774-8.028a5.766,5.766,0,0,0-.394-8.353Z"
						transform="translate(0.012 -31.967)"
						fill="currentColor"
					/>
				</svg>
			),
			authRoute: true,
			href: {
				pathname: `/${RouteLocal.Account.route.t()}`,
				query: { tab: ACCOUNT_QUERY_TABS.FAVORITES },
			},
		},
		{
			name: 'Centro de Ayuda',
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
					<path
						id="lifebuoy"
						d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM5.625,9A3.375,3.375,0,1,1,9,12.375,3.375,3.375,0,0,1,5.625,9Zm10.652,3.014h0l-3.119-1.292a4.512,4.512,0,0,0,0-3.445l3.119-1.292a7.9,7.9,0,0,1,0,6.028ZM12.014,1.723h0L10.722,4.842a4.512,4.512,0,0,0-3.445,0L5.986,1.723a7.9,7.9,0,0,1,6.028,0ZM1.723,5.986,4.842,7.278a4.511,4.511,0,0,0,0,3.445L1.723,12.014a7.9,7.9,0,0,1,0-6.028ZM5.986,16.277l1.292-3.119a4.512,4.512,0,0,0,3.445,0l1.292,3.119a7.9,7.9,0,0,1-6.028,0Z"
						fill="currentColor"
					/>
				</svg>
			),
			authRoute: false,
			href: `/${RouteLocal.HelpCenter.route.t()}`,
		},
		{
			name: 'Mis pedidos',
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
					<path
						id="box"
						d="M77.569,36.743,72,39.964l-5.569-3.222L71.6,33.791a.825.825,0,0,1,.284-.1.79.79,0,0,1,.523.1ZM71.621,49.649a.8.8,0,0,0,.762,0,2.437,2.437,0,0,0,.814-.288l5.6-3.2a2.39,2.39,0,0,0,1.039-1.211A2.438,2.438,0,0,0,80,44.08v-6.4a2.385,2.385,0,0,0-.251-1.067.811.811,0,0,0-.2-.334c-.025-.034-.051-.069-.078-.1a2.428,2.428,0,0,0-.665-.572L73.2,32.4a2.391,2.391,0,0,0-1.563-.291,2.433,2.433,0,0,0-.83.29l-5.6,3.2a2.4,2.4,0,0,0-.753.68.812.812,0,0,0-.2.334c-.032.064-.061.13-.086.2a2.456,2.456,0,0,0-.163.862V44.08a2.387,2.387,0,0,0,.531,1.5,2.428,2.428,0,0,0,.665.572l5.607,3.2a2.363,2.363,0,0,0,.818.29Zm-.421-8.3v6.393L66,44.774a.83.83,0,0,1-.228-.2.784.784,0,0,1-.176-.5v-5.97Zm1.6,6.393V41.35l5.6-3.239v5.97a.828.828,0,0,1-.056.29.787.787,0,0,1-.341.4Z"
						transform="translate(-64 -32.082)"
						fill="currentColor"
					/>
				</svg>
			),
			authRoute: true,
			query: { step: ACCOUNT_QUERY_TABS.ORDERS_HISTORY },
			href: {
				pathname: `/${RouteLocal.Account.route.t()}`,
				query: { tab: ACCOUNT_QUERY_TABS.ORDERS_HISTORY },
			},
		},
	];

	return (
		<Box>
			{linksToActions.map(({ href, icon, name, authRoute }) => (
				<MobileLink
					href={authRoute && !isLoggedIn ? `/${RouteLocal.Login.route.t()}` : href}
					icon={icon}
					key={name}
					name={name}
					sx={headerMobileLinkLightSX}
					onClick={closeDrawer}
				/>
			))}
			<ShowByCondition condition={isLoggedIn}>
				<MobileLink
					icon={<ExitToAppOutlined sx={{ fontSize: '20px' }} />}
					name="Cerrar sesión"
					sx={headerMobileLinkLightSX}
					onLinkClick={handleLogout}
				/>
			</ShowByCondition>
		</Box>
	);
};
